import React, { useState } from "react";
import {
  Container,
  Box,
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Typography,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import { RemoveRedEyeOutlined } from "@mui/icons-material";
import { NURSING_BED_HISTORY } from "../_mock/mock";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { useGetApi } from "../hooks/useGetApi";
import {
  geBedHistoryByVisitIdApi,
  geUnitTransferByVisitIdApi,
} from "../services/consultation.service";
import dayjs from "dayjs";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "../utils/constants";
import Loader from "../components/Loader/loader";
import ErrorMessage from "../components/ErrorMessage/errorMessage";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const headLabel = [
  {
    id: 1,
    label: "Date",
    value: "date",
  },
  {
    id: 2,
    label: "Old Ward",
    value: "oldWard",
  },
  {
    id: 3,
    label: "Old Room",
    value: "oldRoom",
  },
  {
    id: 4,
    label: "New Ward",
    value: "newWard",
  },
  {
    id: 5,
    label: "New Room",
    value: "newRoom",
  },
  {
    id: 9,
    label: "Requested By",
    value: "requestedBy",
  },
  {
    id: 6,
    label: "Approved By",
    value: "approvedBy",
  },
  {
    id: 7,
    label: "Reason",
    value: "reason",
  },
  // {
  //   id: 8,
  //   label: "",
  //   value: "",
  // },
];

const NursingBedHistory = () => {
  const [page, setPage] = useState(0);
  const { visitId } = useParams();
  const navigate = useNavigate();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {
    dataList: allData,
    isLoading,
    isError,
    refetch,
  } = useGetApi({
    apiFunction: geBedHistoryByVisitIdApi,
    params: {
      limit: Number.MAX_SAFE_INTEGER,
      visitId: visitId,
    },
    rawData: true,
  });
  const patientInfo = allData?.patientInfo || {};
  const bedHistory = allData?.bedHistory || [];
  const pagedBedHistory = bedHistory?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              padding: 2,
              marginTop: 2,
              borderRadius: 2,
              marginRight: "90px",
            }}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                color: "#5D6A82",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: "bold",
                padding: 0,
                transition: "none !important",
                marginBottom: "16px",
              }}
            >
              Back
            </Button>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 0,
                mb: "20px",
                color: "#5D6A82",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "20px",
                  lineHeight: "29px",
                  letterSpacing: "0px",
                  color: "inherit",
                }}
              >
                Bed History
              </Typography>
            </Box>
            {isLoading ? (
              <Loader />
            ) : isError ? (
              <ErrorMessage />
            ) : (
              <>
              {/* Patient Information */}
              <Box
                sx={{
                  border: `1px solid #CCD4DA`,
                  borderRadius: "12px",
                  p: 2,
                  mb: "30px",
                }}
              >
                <Typography sx={{ color: "#5D6A82", mb: 2, fontSize: "14px" }}>
                  Patient Information
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="UHID"
                      value={patientInfo?.uhid || ""}
                      fullWidth
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="Patient Name"
                      value={patientInfo?.patientName || ""}
                      fullWidth
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="Age"
                      value={patientInfo?.age || ""}
                      fullWidth
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="Gender"
                      value={patientInfo?.gender || ""}
                      fullWidth
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <DatePicker
                      label="Admission Date"
                      value={
                        patientInfo?.admissionDate
                          ? dayjs(patientInfo.admissionDate)
                          : null
                      }
                      slotProps={{
                        textField: {
                          required: true,
                          fullWidth: true,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="Doctor's Name"
                      fullWidth
                      value={patientInfo?.doctorName || ""}
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="Ward Name"
                      value={patientInfo?.wardName || ""}
                      fullWidth
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <TextField
                      label="Bed Number"
                      value={patientInfo?.bedNumber || ""}
                      fullWidth
                      required
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Table */}

              <TableContainer component={Paper}>
                <Table aria-label="bed history" sx={{ minWidth: 800 }}>
                  <TableHead
                    sx={{
                      backgroundColor: "#f5f5f5",
                      "& th": { fontWeight: "bold" },
                    }}
                  >
                    <TableRow>
                      {headLabel?.map((option) => (
                        <TableCell
                          key={option?.id}
                          sx={{ textAlign: option?.align || "left" }}
                        >
                          {option?.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pagedBedHistory?.map((row) => (
                      <TableRow key={row?._id}>
                        <TableCell>
                          {row?.date
                            ? dayjs(row?.date).format("YYYY-MM-DD")
                            : "-"}
                        </TableCell>
                        <TableCell>{row?.oldWard || "-"}</TableCell>
                        <TableCell>{row?.oldRoom || "-"}</TableCell>
                        <TableCell>{row?.newWard || "-"}</TableCell>
                        <TableCell>{row?.newRoom || "-"}</TableCell>
                        <TableCell>{row?.requestedBy || "-"}</TableCell>
                        <TableCell>{row?.approvedBy || "-"}</TableCell>
                        <TableCell>{row?.reason || "-"}</TableCell>
                        {/* <TableCell>
                          <IconButton>
                            <RemoveRedEyeOutlined />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}

              <TablePagination
                rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
                component="div"
                count={bedHistory?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default NursingBedHistory;
